








$(function() {
    var section = $(".branding-alt");
    var section2 = $(".branding");
    var logo = $(".pisys-logo");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 20) {
            section.removeClass('branding-alt').addClass("branding");

        } else {
            section.removeClass("branding").addClass('branding-alt');

        }

        if (scroll >= 20) {

            section.css("padding", "5px 0 5px");
            section2.css("padding", "5px 0 5px");
             logo.css("background-size", "auto");
             logo.css("height", "40px");
             logo.css("width", "140");
        } else {

            section.css("padding", "20px 0 20px");
            section2.css("padding", "20px 0 20px");
            logo.css("background-size", "200px");
            logo.css("height", "60px");
            logo.css("width", "200");
        }


    });
});

